import React, { createContext, useContext, useState } from "react";

type SidebarContextType = {
  showSidebar: boolean;
  setShowSidebar: React.Dispatch<React.SetStateAction<boolean>>;
};

const INITIAL_CONTEXT_STATE: SidebarContextType = {
  showSidebar: false,
  setShowSidebar: () => {},
};

export const SidebarContext = createContext(INITIAL_CONTEXT_STATE);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context != undefined) {
    return context;
  } else {
    throw new Error("useSidebar must be used within SidebarProvider");
  }
};

export const SidebarProvider = ({ children }: { children: JSX.Element }) => {
  const [showSidebar, setShowSidebar] = useState(true);

  return (
    <SidebarContext.Provider value={{ showSidebar, setShowSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};
